import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import MuiList from '@mui/material/List';
import MuiListSubheader from '@mui/material/ListSubheader';
import * as React from 'react';
import { ListItem } from './list-item';
export { ListItem } from './list-item';
export { SearchListItem } from './search-list-item';
export const List = (props) => {
    const { items = [], sx, subheader, footer, width, height, children, ...muiProps } = props;
    if (items?.length && children) {
        console.warn('List component should not have both items and children defined. Please use one or the other.');
    }
    return (_jsxs(MuiList, { sx: {
            width: width ?? '100%',
            height,
            overflow: 'auto',
            overscrollBehavior: 'contain',
            borderRadius: 1,
            ...(footer ? { pb: 0 } : {}),
            ...sx
        }, subheader: subheader && (_jsx(MuiListSubheader, { "data-role": "subheader", children: subheader })), ...muiProps, children: [items.length > 0
                ? items.map((itemProps, i) => (_jsx(ListItem, { ...itemProps }, i)))
                : children, footer && (_jsx(MuiListSubheader, { "data-role": "footer", sx: { display: 'flex', minHeight: 48, bottom: 0, px: 0 }, children: footer }))] }));
};
